import React from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cn from 'classnames';
import size from 'lodash/size';

import Avatar from '../../Avatar';
import { SelectedSizeInfo } from '../SearchDialog/SearchDialogImpl/SelectedSizeInfo';
import styles from './index.styl';

const SelectableList = ({ items, onSelect, white, className }) => {
  return (
    <div styleName={cn('list', { 'list--white': white })} className={className}>
      <div styleName="counter">
        <SelectedSizeInfo
          textId={{ id: 'chat.title.membersCounter' }}
          size={size(items)}
        />
      </div>
      <ul>
        {items.map(item => {
          const {
            dob,
            city,
            id,
            displayableName,
            username,
            role,
            organizationName,
            avatar,
            teamActingUser,
          } = item;
          const additionalInfo = dob || city;
          const name = displayableName || username;

          return (
            <li styleName="item" onClick={() => onSelect(item)} key={id}>
              <div styleName="wrapper">
                <Avatar
                  style={{ marginLeft: '5px' }}
                  children={name && name.charAt(0).toUpperCase()}
                  size={40}
                  src={get(avatar, 'thumbMin')}
                />
                <div styleName="content">
                  <div
                    className={
                      additionalInfo
                        ? 'flex flex-column'
                        : 'flex flex-row items-center'
                    }
                  >
                    <div>
                      <span styleName="title title--primary title--left">
                        {name}
                      </span>
                      <If condition={!teamActingUser}>
                        <span styleName="title title--secondary title--left">
                          {username}
                        </span>
                      </If>
                    </div>
                    <If condition={!teamActingUser && additionalInfo}>
                      <span
                        styleName="title title--secondary title--left"
                        className="mt2"
                      >
                        {`${dob || ''}${dob && city ? `,` : ''} ${city || ''}`}
                      </span>
                    </If>
                  </div>
                  <div styleName="role-content">
                    <span styleName="role">
                      <If condition={!teamActingUser}>
                        {`${role || ''}${
                          role && organizationName ? `,` : ''
                        } ${organizationName || ''}`}
                        <Else />
                        {`${organizationName || ''}`}
                      </If>
                    </span>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

SelectableList.propTypes = {
  items: PropTypes.array,
  onSelect: PropTypes.func,
  white: PropTypes.bool,
  className: PropTypes.string,
};

export default CSSModules(SelectableList, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/List/SelectableList.jsx